Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _constants = require('../../constants');

exports['default'] = _react.PropTypes.oneOf([_constants.HORIZONTAL_ORIENTATION, _constants.VERTICAL_ORIENTATION]);


//////////////////
// WEBPACK FOOTER
// ./~/react-dates/lib/shapes/OrientationShape.js
// module id = 115
// module chunks = 0